import { IssueSeverityEnum, IssueSeverityType } from '@issuemanager/constants';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export function useSeverityLocalizer() {
  const { t } = useTranslation('common');

  const severityMap = useMemo(
    () => ({
      [IssueSeverityEnum.LOW]: t('severity.low'),
      [IssueSeverityEnum.MEDIUM]: t('severity.medium'),
      [IssueSeverityEnum.HIGH]: t('severity.high'),
      [IssueSeverityEnum.CRITICAL]: t('severity.critical'),
    }),
    [t],
  );

  function isValidSeverityKey(key: string): key is IssueSeverityType {
    return key in severityMap;
  }

  return (value?: string): string | undefined => {
    if (!value) return undefined;
    return isValidSeverityKey(value) ? severityMap[value] : value;
  };
}

export type SeverityTypeData = {
  id: string;
  value: IssueSeverityType;
  label: string;
};
